import { DrawerLinkType } from 'components/Drawer/types';
import {
  getWorkOrdersHome,
  isWorkOrdersPath,
  WorkOrderAccess,
} from 'modules/Orders/workOrderNavigation';

const PRIVILEGED_ONLY = [
  'DRAWER.TIMESHEETS',
  'DRAWER.REPORTS',
  'DRAWER.ADMIN_PANEL',
];

// Top navigation. Work orders, oversight, coverage and employment forms share
// one Work Orders item; their own tab bar lives inside the section.
export const getNavigationItems = (
  access: WorkOrderAccess,
  hideTabsForPrivilegedUsers: boolean,
): DrawerLinkType[] => {
  const workOrdersHome = getWorkOrdersHome(access);
  const items: DrawerLinkType[] = [
    { label: 'DRAWER.TIMESHEETS', to: '/timesheets', id: 'menu_timesheets' },
    { label: 'DRAWER.WORKTIME', to: '/worktime', id: 'menu_worktime' },
    { label: 'DRAWER.REPORTS', to: '/reports', id: 'menu_reports' },
    ...(workOrdersHome
      ? [
          {
            label: 'DRAWER.ORDERS',
            to: workOrdersHome,
            id: 'menu_work_orders',
            isActive: isWorkOrdersPath,
          },
        ]
      : []),
    { label: 'DRAWER.PROJECTS', to: '/projects', id: 'menu_projects' },
    { label: 'DRAWER.CLIENTS', to: '/clients', id: 'menu_clients' },
    { label: 'DRAWER.ADMIN_PANEL', to: '/adminpanel', id: 'menu_adminPanel' },
    {
      label: 'DRAWER.BUSINESS_TRIPS',
      to: '/trips',
      id: 'menu_businessTrips',
    },
  ];

  return hideTabsForPrivilegedUsers
    ? items.filter(({ label }) => !PRIVILEGED_ONLY.includes(label))
    : items;
};

export const isNavigationItemActive = (
  { to, isActive }: DrawerLinkType,
  pathname: string,
) => (isActive ? isActive(pathname) : pathname === to);
